const comments = [
  {
    name: '光影旅人',
    date: '2026-07-28',
    rating: 5,
    text: '用了春夜影院半年多了，画质真的没话说，蓝光资源特别多。之前在其他平台看总是卡顿，这里几乎没有缓冲过，观影体验太舒服了。',
  },
  {
    name: '周末影迷',
    date: '2026-07-25',
    rating: 5,
    text: '资源更新速度真的快，新剧刚播完第二天就能在这找到高清版。界面也很干净，没有乱七八糟的弹窗广告，体验比想象中好太多了。',
  },
  {
    name: '追剧达人小陈',
    date: '2026-07-22',
    rating: 4,
    text: '分类做得很细致，找片子特别方便。综艺和动漫资源也很全，之前想找一部老番找了很久，居然在这找到了高清版本，果断收藏了。',
  },
  {
    name: '电影爱好者阿明',
    date: '2026-07-19',
    rating: 5,
    text: '作为一个重度电影爱好者，春夜的片库真的让我惊喜。从经典老片到最新院线，类型覆盖很全面。画质和音效都达到了我的期望。',
  },
  {
    name: '深夜看片人',
    date: '2026-07-16',
    rating: 5,
    text: '晚上睡不着的时候就打开春夜找部电影看，流畅度真的稳。不需要注册就能看，这点特别好。推荐给了好几个朋友，都说好用。',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            观众热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            听听他们怎么说——真实观众的观影体验与评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {comments.slice(0, 2).map((c, idx) => (
            <article
              key={idx}
              className="lg:col-span-2 bg-background-100 rounded-lg p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center text-background-50 font-heading font-bold text-sm">
                  {c.name.charAt(0)}
                </div>
                <div>
                  <div className="font-medium text-sm text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.date}</div>
                </div>
                <div className="ml-auto flex gap-0.5">
                  {Array.from({ length: c.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{c.text}</p>
            </article>
          ))}

          {comments.slice(2).map((c, idx) => (
            <article key={idx + 2} className="bg-background-100 rounded-lg p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-secondary-500 flex items-center justify-center text-background-50 font-heading font-bold text-sm">
                  {c.name.charAt(0)}
                </div>
                <div>
                  <div className="font-medium text-sm text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.date}</div>
                </div>
                <div className="ml-auto flex gap-0.5">
                  {Array.from({ length: c.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{c.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}